export const Status = {
  0: 'Pendiente',
  1: 'Pagado'
};